import { useStoreConfig } from '~/store/storeConfig'
import { decrypt } from '~/utils/encrypt-string'

export const useMarketplaceLock = () => {
  const { isTarpininke } = useTheme()
  const config = useStoreConfig()
  const mpLockConfig = computed(() => config.site?.marketplace_config || null)

  const passwordEntered = ref('')
  let stopWatch: (() => void) | undefined

  if (typeof window !== 'undefined') {
    const localPass = useLocalStorage<string>('mpLockPass', '')
    passwordEntered.value = localPass.value

    stopWatch = watch(localPass, (val) => {
      passwordEntered.value = val
    })
  }

  const passwordLock = computed(() => !!mpLockConfig.value?.lock_password)
  const timerLock = computed(() => !!mpLockConfig.value?.lock_expiration_date)

  const timeLeft = computed(() => {
    if (!timerLock.value) return null
    const lockTime = new Date(mpLockConfig.value?.lock_expiration_date ?? 0).getTime()

    return lockTime - Date.now()
  })

  const isUnlocked = computed(() => {
    if (!isTarpininke || (!mpLockConfig.value?.lock_password && !mpLockConfig.value?.lock_expiration_date)) {
      return true
    }

    const decryptedPass = (() => {
      try {
        return decrypt(mpLockConfig.value.lock_password)
      } catch (e) {
        console.error('Decryption failed:', e)

        return null
      }
    })()

    const passwordMatch = decryptedPass === passwordEntered.value
    const timerExpired = timerLock.value && timeLeft.value !== null && timeLeft.value <= 0

    return passwordMatch || timerExpired
  })

  // Clean up the watcher when the composable is no longer used
  onBeforeUnmount(() => {
    if (stopWatch) {
      stopWatch()
    }
  })

  return {
    pass: mpLockConfig.value?.lock_password || null,
    passwordLock,
    timerLock,
    isTimerActive: timeLeft.value !== null,
    timeLeft,
    isUnlocked,
    endTime: mpLockConfig.value?.lock_expiration_date || null,
    title: mpLockConfig.value?.lock_title || '',
    description: mpLockConfig.value?.lock_description || '',
  }
}
